import { ICustomerCreate, ICustomerDetails, ICustomerListSearch, IEditCustomerPayload, IGetCustomerList } from "../../../types/master/customerInterface";
import { CustomerActionTypes, CustomerActions } from "../../actionTypes/master/customerActionTypes";


export const createCustomer = (payload: ICustomerCreate): CustomerActionTypes => ({
  type: CustomerActions.CREATE_CUSTOMER,
  payload,
});

export const getCustomerList = (payload: ICustomerListSearch): CustomerActionTypes => ({
  type: CustomerActions.GET_CUSTOMER_LIST,
  payload,
});

export const setCustomerList = (customerList: Array<IGetCustomerList>) : CustomerActionTypes => ({
  type: CustomerActions.SET_CUSTOMER_LIST,
  payload: customerList
})

export const setCustomerListPageCount = (payload:number): CustomerActionTypes => ({
  type: CustomerActions.SET_CUSTOMER_LIST_PAGE_COUNT,
  payload
})

export const getCustomerDataById = (id: number | string): CustomerActionTypes => ({
  type: CustomerActions.GET_CUSTOMER_DATA_BY_ID,
  payload: id
})

export const setCustomerDataById = (payload: ICustomerDetails) => ({
  type: CustomerActions.SET_CUSTOMER_DATA_BY_ID,
  payload
})

export const editCustomer = (payload: IEditCustomerPayload) => ({
  type: CustomerActions.EDIT_CUSTOMER_DETAILS,
  payload,
});
